import { NextPage } from "next";
import WebComponent from "components/pages/w/login";
import MobileComponent from "components/pages/m/login";
import { getProviders } from "next-auth/react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSidePropsContext } from "next";
import { CustomSession, Providers } from "interfaces/login";
import Login from "components/pages/Login";
import { detectMetaIABFromHeaders } from "utils/api/detectMetaIAB";
import { getServerSession } from "next-auth";
import { authOptions } from "./api/auth/[...nextauth]";

interface Props {
  isMobile: boolean;
  providers: Providers;
  isIAB: boolean;
}

const Main: NextPage<Props> = ({ isMobile, providers, isIAB }) => {
  return <Login providers={providers} isMobile={isMobile} isIAB={isIAB} />;
  // return isMobile ? (
  //   <MobileComponent providers={providers} />
  // ) : (
  //   <WebComponent providers={providers} />
  // );
};

export default Main;

export async function getServerSideProps({
  locale = "ko",
  req,
  res,
  query,
}: GetServerSidePropsContext) {
  const providers = await getProviders();
  const detection = detectMetaIABFromHeaders(req.headers as any);
  const session = await getServerSession(req, res, authOptions);

  const rawFrom = typeof query.from === "string" ? query.from : undefined;
  const decodedFrom = rawFrom ? decodeURIComponent(rawFrom) : undefined;

  // 내부 경로만 허용
  const isSafeInternal = decodedFrom && decodedFrom.startsWith("/");
  const safeDest = isSafeInternal ? decodedFrom : "/";

  // (선택) 쿠키로도 심어두고 싶으면:
  res.setHeader("Set-Cookie", [
    `is_iab=${detection.isMetaIAB ? "1" : "0"}; Path=/; SameSite=Lax`,
  ]);

  // 이미 로그인 상태면 서버에서 즉시 리다이렉트
  if (session) {
    // 전화번호 미입력 케이스 우선 처리
    if (!(session.user as CustomSession)?.phone) {
      const toSignup = `/signup?social=true${
        rawFrom ? `&from=${encodeURIComponent(decodedFrom!)}` : ""
      }`;
      return {
        redirect: { destination: toSignup, permanent: false },
      };
    }
    return {
      redirect: { destination: safeDest, permanent: false },
    };
  }

  return {
    props: {
      providers,
      isIAB: detection?.isMetaIAB || false,
      ...(await serverSideTranslations(locale as string, ["login"])),
    },
  };
}
